import { render, staticRenderFns } from "./CmgFavoriteRestaurantModal.vue?vue&type=template&id=40d4c572&scoped=true&lang=pug"
import script from "./cmg-favorite-restaurant-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-favorite-restaurant-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgFavoriteRestaurantModal.vue?vue&type=style&index=0&id=40d4c572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d4c572",
  null
  
)

export default component.exports